<template>
  <div v-if="feedback.length > 0" class="alert alert-danger mt-3">
    <div v-for="text in feedback">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputFeedback',
  props: {
    errors: {
      type: Object,
      default: {},
    },
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    feedback() {
      if (this.errors.hasOwnProperty(this.name)) {
        return this.errors[this.name];
      }

      return [];
    },
  },
};
</script>

<style scoped>

</style>